import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import {
  Field,
  FieldArray,
  InjectedFormProps,
  WrappedFieldArrayProps,
  formValueSelector,
  reduxForm,
} from "redux-form";
import { PastCaseProject } from "src/domain/model/past_case_project";
import { Multi_SkillTag } from "src/domain/model/skill_tag";
import Assets from "src/presentation/assets/img/assets";
import styled from "styled-components";
import {
  customerConfig,
  jobCareerConfig,
  projectConfig,
  skillTagConfig,
} from "../../../../../config/language/ja-JP/domain/model_text";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
} from "../../../../../config/styles_const/styles_const";
import { Customer } from "../../../../../domain/model/customer";
import { JobCareer } from "../../../../../domain/model/job_career";
import { entity } from "../../../../../infra/api/rpc/api";
import {
  createMonthArray,
  createYearsArray,
} from "../../../../../util/commonFuntion";
import {
  createAddressOptionDom,
  createOptionsFromMap,
  createSelectItem,
} from "../../../../../util/select_option_function";
import * as Validator from "../../../../../util/validation";
import BtnBorderMiddle from "../../../../common/atom/btn/btn_border_middle";
import BtnCancelMiddle from "../../../../common/atom/btn/btn_cancel_middle";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import ErrorText from "../../../../common/atom/text/error_text";
import Paragraph from "../../../../common/atom/text/paragraph";
import DatepickerWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/datepicker_wrapper";
import MonthDaysWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/month_days_wrapper";
import YearWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/year_wrapper";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupCheckbox from "../../../../common/molecular/form_group/form_group_checkbox";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupMultiSelectConnectRf from "../../../../common/molecular/form_group/form_group_multi_select_connect_rf";
import FormGroupSelectConnectRf from "../../../../common/molecular/form_group/form_group_select_connect_rf";
import FormGroupTextareaConnectRf from "../../../../common/molecular/form_group/form_group_textarea_connect_rf";
import { AppState } from "../../../../store/app_state";

const validate = (values: any) => {
  const errors: any = {};

  return errors;
};

interface IMyFieldValue {
  num: number;
  jobCareer: JobCareer;
}

interface IRenderJobCareersProps extends WrappedFieldArrayProps<IMyFieldValue> {
  change: any;
  jobCareers: JobCareerForValidate[];
}

type JobCareerForValidate = {
  occupations: number[];
};

const renderJobCareers: React.FC<IRenderJobCareersProps> = (props) => {
  const { change, fields, meta } = props;

  return (
    <React.Fragment>
      <JobCareerTitleWrapper id="jobCareer">
        <Paragraph bold={true}>職歴・業務履歴・職種</Paragraph>
      </JobCareerTitleWrapper>

      {fields.map((jobCareer: any, index: number) => {
        return (
          <ItemWrapper key={index}>
            <RenderJobCareer
              jobCareer={jobCareer}
              change={change}
              index={index}
              key={index}
              jobCareers={props.jobCareers}
            />
            <JobCareerCancelWrapper>
              <BtnCancelMiddle
                type="button"
                onClick={fieldsRemove(
                  { fields, meta: { error: meta.error } },
                  index
                )}
              >
                職歴項目を削除
              </BtnCancelMiddle>
            </JobCareerCancelWrapper>
          </ItemWrapper>
        );
      })}
      <JobCareerAddWrapper>
        <BtnBorderMiddle
          type="button"
          onClick={fieldsPush({ fields, meta: { error: meta.error } })}
        >
          職歴項目を追加
        </BtnBorderMiddle>
      </JobCareerAddWrapper>
      {meta.error && <li className="error">{meta.error}</li>}
    </React.Fragment>
  );
};

interface IRenderJobCareer {
  jobCareer: any;
  index: number;
  change: any;
  jobCareers: JobCareerForValidate[];
}

const RenderJobCareer: React.FC<IRenderJobCareer> = (props) => {
  const { jobCareer, change, index, jobCareers } = props;

  const [changedOccupation, setChangedOccupation] = useState(false);

  const [isDuringEmployment, setIsDuringEmployment] = useState(false);
  const handleClickIsDuringEmployment = () => {
    // 在職中のスイッチが押されたら終了年と終了月のvalueを初期値へ
    // 在職中のstatusはこのコンポーネントのstatusにて管理
    if (!isDuringEmployment) {
      change(`jobCareers[${index}].endedAt.year`, "");
      change(`jobCareers[${index}].endedAt.month`, "");
    }
    setIsDuringEmployment(!isDuringEmployment);
  };

  return (
    <React.Fragment>
      <FormFieldWrapper>
        <Field
          name={`${jobCareer}.companyName`}
          type="text"
          component={FormGroupInputConnectRf}
          label="会社名"
          placeholder="株式会社〇〇ホールディングス"
          validate={[Validator.companyName, Validator.required]}
          require={true}
        />
      </FormFieldWrapper>

      <FormFieldWrapper>
        <Field
          name={`${jobCareer}.post`}
          type="text"
          component={FormGroupInputConnectRf}
          label="役職"
          placeholder="執行役員"
          validate={[Validator.jobCareerPost]}
        />
      </FormFieldWrapper>

      <FormFieldWrapper>
        <DatepickerWrapper>
          <YearWrapper>
            <Field
              label="開始年"
              name={`${jobCareer}.startedAt.year`}
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[Validator.required]}
              require={true}
              placeholder="2012"
            >
              {createAddressOptionDom(createYearsArray(60))}
            </Field>
          </YearWrapper>

          <MonthDaysWrapper>
            <Field
              label="開始月"
              name={`${jobCareer}.startedAt.month`}
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[]}
              placeholder="1"
            >
              {createAddressOptionDom(createMonthArray())}
            </Field>
          </MonthDaysWrapper>
        </DatepickerWrapper>
      </FormFieldWrapper>
      <FormFieldWrapper>
        <DatepickerWrapper>
          <YearWrapper>
            <Field
              label="終了年"
              name={`${jobCareer}.endedAt.year`}
              component={FormGroupSelectConnectRf}
              type="text"
              disabled={isDuringEmployment}
              validate={[]}
              placeholder="2021"
            >
              {createAddressOptionDom(createYearsArray(60))}
            </Field>
          </YearWrapper>

          <MonthDaysWrapper>
            <Field
              label="終了月"
              name={`${jobCareer}.endedAt.month`}
              component={FormGroupSelectConnectRf}
              type="text"
              disabled={isDuringEmployment}
              validate={[]}
              placeholder="8"
            >
              {createAddressOptionDom(createMonthArray())}
            </Field>
          </MonthDaysWrapper>
          <DuringEmployment>
            <FormGroupCheckbox
              name={`${jobCareer}.duringEmployment`}
              label={`在職中`}
              hasError={false}
              errorText={``}
              input={{
                value: isDuringEmployment,
                onChange: handleClickIsDuringEmployment,
              }}
            />
          </DuringEmployment>
        </DatepickerWrapper>
      </FormFieldWrapper>

      <FormFieldWrapper>
        <Field
          name={`${jobCareer}.description`}
          type="text"
          component={FormGroupTextareaConnectRf}
          label="業務内容"
          placeholder="経営企画業務
・ グループ全体の事業戦略、資本政策、年次予算の作成、予実管理業務
・ M&A、子会社の売却、合併、増資、清算手続等
・ 株主対応(VCに対し月次、四半期の決算報告)
          "
          rows={3}
          validate={[Validator.jobCareerDescription, Validator.required]}
          require={true}
        />
      </FormFieldWrapper>

      <FormFieldWrapper>
        <Field
          name={`${jobCareer}.occupations`}
          label="職種"
          placeholder="経営企画"
          component={FormGroupMultiSelectConnectRf}
          type="select-multiple"
          isMulti={true}
          options={createOptionsFromMap(projectConfig.occupationList)}
          validate={[Validator.jobCareerOccupations, Validator.required]}
          require={true}
          onChange={() => {
            setChangedOccupation(true);
          }}
        />
        {jobCareers &&
          jobCareers.length !== 0 &&
          jobCareers[index] &&
          jobCareers[index].occupations &&
          jobCareers[index].occupations.length > 1 &&
          !changedOccupation && (
            <MyError>職種は1つだけ選択してください</MyError>
          )}
      </FormFieldWrapper>

      <FormFieldWrapper>
        <Field
          label={"契約形態"}
          name={`${jobCareer}.employmentStatus`}
          component={FormGroupSelectConnectRf}
          type="text"
          validate={[Validator.requiredSelect]}
          require={true}
        >
          {createSelectItem(true, jobCareerConfig.employmentStatusList)}
        </Field>
      </FormFieldWrapper>
    </React.Fragment>
  );
};

const fieldsPush = (p: { fields: any; meta: { error: any } }) => () => {
  p.fields.push();
};

const fieldsRemove =
  (p: { fields: any; meta: { error: any } }, index: number) => () => {
    p.fields.remove(index);
  };

interface IStateProps {
  initialValues:
    | {
        customer: Customer | null;
        jobCareers: JobCareer[];
        pastCaseProjects: PastCaseProject[];
        tags_1: string[];
        tags_7: string[];
        tags_5: string[];
        tags_3: string[];
        tags_4: string[];
        tags_6: string[];
      }
    | undefined;
  formValues: any;
}

interface IProps extends IStateProps {
  tags: entity.IMultiSkillTag[];
  onGenerateDutySummary: () => void;
  generatedDutySummary: string | undefined;
}

interface IState {}

class JobCareerEditForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {};
  }

  public componentWillUpdate(nextProps: any, nextState: any): void {
    // 更新実行後の初期化処理
    if (
      this.props.formValues &&
      this.props.initialValues.customer &&
      nextProps.initialValues.customer.gsIconURL !==
        this.props.initialValues.customer.gsIconURL
    ) {
      URL.revokeObjectURL(this.props.formValues.preview);
    }
  }

  public componentWillUnmount(): void {
    // Make sure to revoke the data uris to avoid memory leaks
    if (this.props.formValues != null) {
      URL.revokeObjectURL(this.props.formValues.preview);
    }
  }

  public componentDidUpdate(prevProps: IProps & InjectedFormProps<{}, IProps>) {
    if (this.props.generatedDutySummary) {
      if (prevProps.generatedDutySummary !== this.props.generatedDutySummary) {
        this.props.change(
          "customer.dutySummary",
          this.props.generatedDutySummary
        );
      }
    }
  }

  public render(): JSX.Element {
    const {
      anyTouched,
      invalid,
      handleSubmit,
      pristine,
      submitting,
      change,
      tags,
    } = this.props;

    const customer: Customer | null = this.props.initialValues
      ? this.props.initialValues.customer
      : null;

    if (!customer) {
      return <div />;
    }

    let res: JSX.Element;

    const tagsByCategory = (category: Multi_SkillTag.Category) => {
      const selection = (): any[] => {
        const options: any[] = [];
        options.push({ value: 0, label: "", isDisabled: true });
        tags
          .filter((v) => v.category === category)
          .forEach((item) => {
            options.push({ value: item.id, label: item.name });
          });
        return options;
      };

      return (
        <>
          <FormFieldWrapper>
            <Field
              name={`tags_${category}`}
              label={skillTagConfig.multiSkillTagCategoryList.get(category)}
              placeholder=""
              component={FormGroupMultiSelectConnectRf}
              type="select-multiple"
              isMulti={true}
              options={selection()}
              validate={[]}
              require={false}
            />
          </FormFieldWrapper>
        </>
      );
    };

    // 編集ページ
    res = (
      <React.Fragment>
        <form name="JobCareerEditForm" onSubmit={handleSubmit}>
          <FormFieldWrapper id="dutySummary">
            <OpenAILink>
              <OpenAILinkText
                onClick={() => {
                  this.props.onGenerateDutySummary();
                }}
              >
                生成AIで職務要約の下書きを行う
              </OpenAILinkText>
              <OpenAILinkIconContainer>
                <OpenAILinkIcon
                  src={Assets.help}
                  onClick={() => {
                    this.setState({ showHelp: true });
                  }}
                />
                <OpenAITooltip>
                  生成AIを用いて、あなたの職歴情報から職務要約の下書きを作成する機能です。
                  <br />
                  この機能を使用するには、最低2件以上の職歴情報を保存しておく必要があります。
                  <br />
                  下書きを行うボタンを押すと、ポップアップが表示され、下書きが作成されます。
                  <br />
                  その情報を必要に応じて書き換えて保存することができます。
                </OpenAITooltip>
              </OpenAILinkIconContainer>
            </OpenAILink>
            <Field
              label={customerConfig.dutySummary}
              placeholder={`主に、ITや金融サービスを中心とした上場企業で事業企画業務、M&A/PMIやファイナンスを中心とした経営企画業務に従事。2008年にCFOとして〇〇株式会社の東証一部への市場変更を担当し、2013年には親会社の取締役として〇〇株式会社のマザーズ上場に関与する。直近では、株式会社〇〇のCOOに従事し、2020年8月に株式会社〇〇の取締役に就任。`}
              name="customer.dutySummary"
              rows={3}
              component={FormGroupTextareaConnectRf}
              validate={[Validator.dutySummary]}
            />
          </FormFieldWrapper>

          <FieldArray<IRenderJobCareersProps>
            name={`jobCareers`}
            change={change}
            component={renderJobCareers}
            jobCareers={this.props.initialValues.jobCareers}
          />

          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <TagSection>
            <TagSectionTitle>スキル・経験</TagSectionTitle>
            <TagSectionInner>
              <TagSectionInnerLeft>
                {tagsByCategory(
                  Multi_SkillTag.Category.Category_IntroductionOperation
                )}
                {tagsByCategory(
                  Multi_SkillTag.Category.Category_PersonalConnections
                )}
                {tagsByCategory(
                  Multi_SkillTag.Category.Category_DevelopFramework
                )}
              </TagSectionInnerLeft>
              <TagSectionInnerRight>
                {tagsByCategory(
                  Multi_SkillTag.Category.Category_OverseasExpansion
                )}
                {tagsByCategory(Multi_SkillTag.Category.Category_Programming)}
                {tagsByCategory(Multi_SkillTag.Category.Category_AI)}
              </TagSectionInnerRight>
            </TagSectionInner>
          </TagSection>

          <SubmitButtonWrapper>
            <CancelButtonWrapper>
              <BtnLinkCancelSmall to="/customer/mypage/customer">
                キャンセル
              </BtnLinkCancelSmall>
            </CancelButtonWrapper>
            <BtnCorporateLarge
              name="JobCareerEditForm-submit"
              type="submit"
              widthSize="200px"
              disabled={pristine || submitting || invalid}
            >
              保存
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </React.Fragment>
    );

    return res;
  }
}

const selector = formValueSelector("JobCareerEditForm");

const mapStateToProps = (state: AppState, initialProps: any) => {
  return {
    formValues: selector(state, ""),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm<{}, IProps>({
  form: "JobCareerEditForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(JobCareerEditForm));

const ItemWrapper = styled.div`
  padding: 20px;
  margin: 20px 0;
  background: #fefcf7;

  border: 1px solid ${ConstColor.LightGray};
  border-radius: ${ConstBorderRound.CornerRoundAll};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    padding: 30px;
  }
`;

const JobCareerTitleWrapper = styled.div`
  margin: 20px 0;
`;

const JobCareerCancelWrapper = styled.div`
  text-align: right;
`;

const JobCareerAddWrapper = styled.div`
  text-align: center;
  margin: 20px;
`;

const DuringEmployment = styled.div`
  align-self: center;
`;

const MyError = styled.div`
  color: #ce4141;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 24px;
  &:before {
    margin-right: 5px;
    content: "\f06a";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
  }
`;

const TagSection = styled.div`
  margin-top: 42px;
  border-top: solid 1px #ebf0f1;
  padding: 32px 0px;
`;

const TagSectionTitle = styled.div`
  font-size: 15px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 7px;
`;

const TagSectionInner = styled.div`
  display: flex;
`;

const TagSectionInnerLeft = styled.div`
  flex: 1;
  margin-right: 10px;
`;

const TagSectionInnerRight = styled.div`
  flex: 1;
  margin-left: 10px;
`;

const TagCategory = styled.div`
  font-size: 12px;
  color: #333333;
  font-weight: normal;
  margin-bottom: 7px;
`;

const OpenAILinkText = styled.div`
  color: ${ConstColor.Corporate};
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
`;

const OpenAILinkIcon = styled.img`
  display: block;
  margin-left: 10px;
  cursor: pointer;
`;

const OpenAITooltip = styled.div`
  position: absolute;
  bottom: -80px; // 要素の高さに応じて調整する
  right: 0px;
  background-color: black;
  color: white;
  padding: 5px;
  border-radius: 5px;
  font-size: 10px;
  line-height: 14px;
`;

const OpenAILink = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`;

const OpenAILinkIconContainer = styled.div`
  & > ${OpenAITooltip} {
    display: none;
  }

  // ホバー時にツールチップを表示する
  &:hover > ${OpenAITooltip} {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/edit/job_career_edit_form.tsx